import css from './imageInput.module.scss';

import { memo, ReactEventHandler, useLayoutEffect, useState } from 'react';

import { useImageViewer } from 'com/ImageViewer';
import { TBinaryUpdate } from 'shared/types/domain';

import Button from '../Button';
import Preloader from '../Preloader';
import ICONS from '../icons';
import { useOnPaste } from './useOnPaste';

type ResourceProps = {
  label: string;
  url: string;
  onChange: (update: TBinaryUpdate) => void;
};

function Resource({ url, label, onChange }: ResourceProps) {
  const [info, setInfo] = useState<{ width: number; height: number } | null>(
    null
  );

  useLayoutEffect(() => {
    setInfo(null);
  }, [url]);

  const onImageLoad: ReactEventHandler<HTMLImageElement> = event => {
    const img$ = event.target as HTMLImageElement;
    setInfo({ width: img$.naturalWidth, height: img$.naturalHeight });
  };

  const onPaste = useOnPaste(onChange);

  const removeValue = () => {
    onChange({ action: 'remove', data: '' });
  };

  const imageViewer = useImageViewer();
  return (
    <div className={css.resource}>
      <input
        className={css.input}
        value={`${label}. ${info?.width ?? '?'} x ${info?.height ?? '?'}`}
        // Don't react on changes, but allow to put a focus.
        onChange={() => null}
        onPaste={evt => void onPaste(evt)}
      />
      <div
        className={css.imageContainer}
        onClick={info && url ? () => imageViewer.show(url) : undefined}
      >
        {!url && <Preloader className={css.preloader} />}
        {url && (
          <img
            src={url}
            onLoad={onImageLoad}
            crossOrigin="use-credentials"
            className={css.image}
          />
        )}
      </div>
      <Button
        theme="flat"
        className={css.rmButton}
        children={ICONS.Trash}
        onClick={removeValue}
      />
    </div>
  );
}

export default memo(Resource);
